const renderRuleCardLine = (item, i) => {
    const isPlainString = typeof item === "string";
    const text = isPlainString ? item : item.text;
    const variant = isPlainString ? "default" : item.variant;

    const style = variant === "connector"
      ? { color: "#b0b0b0", fontWeight: 700, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.4px", margin: "1px 0" }
      : variant === "note"
        ? { color: "#969696", fontSize: "11px", fontStyle: "italic", margin: "3px 0 0 0" }
        : { color: "#969696", fontSize: "12px", margin: 0 };

    return <p key={i} style={style}>{text}</p>;
};

const RuleCard = ({
    header,
    subHeader,
    meta = [],
    trigger = [],
    restrictions = [],
    statusChecks = [],
    actions = [],
    rightContent,
    footer,
    onClick,
    active = true
  }) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#fff",
          borderRadius: "12px",
          boxShadow: "0 0 4px rgba(0,0,0,0.15)",
          padding: "20px",
          gap: "8px",
          maxWidth:"400px",
          cursor: onClick ? "pointer" : "default",
          opacity: active ? 1 : 0.5,
          border: active ? "1px solid transparent" : "1px solid var(--Inactive-color)",
        }}
        onClick={onClick}
      >
        {/* Main row */}
        <div style={{ display: "flex", justifyContent: "space-between", gap:"8px" }}>
          {/* LEFT */}
          <div style={{ minWidth: 0, overflow:"hidden", textOverflow:"ellipsis", gap:"8px", maxWidth:"80%" }}>
            <h3 style={{color:"#585966", fontSize:500, fontSize:"17px", marginBottom:"5px"}}>{header}</h3>
            {subHeader && <h4 style={{ margin: 0, color:"#585966", marginBottom:"5px", fontSize:"13px", fontWeight:500 }}>{subHeader}</h4>}

            {meta.map((line, i) => (
              <p key={i}
                style={{
                    color:"#969696",
                    fontWeight: 450,
                    fontSize: "14px",
                    margin: 0,
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical"
                }}>
                {line}
              </p>
            ))}

            {trigger.length > 0 && (
              <div style={{ marginTop: "10px" }}>
                <p style={{ color: "#585966", fontWeight: 600, fontSize: "12px", margin: "0 0 3px 0" }}>Trigger</p>
                {trigger.map(renderRuleCardLine)}
              </div>
            )}

            {restrictions.length > 0 && (
              <div style={{ marginTop: "10px" }}>
                <p style={{ color: "#585966", fontWeight: 600, fontSize: "12px", margin: "0 0 3px 0" }}>Restrictions</p>
                {restrictions.map(renderRuleCardLine)}
              </div>
            )}

            {statusChecks.length > 0 && (
              <div style={{ marginTop: "10px" }}>
                <p style={{ color: "#585966", fontWeight: 600, fontSize: "12px", margin: "0 0 3px 0" }}>Status checks</p>
                {statusChecks.map(renderRuleCardLine)}
              </div>
            )}

            {actions.length > 0 && (
              <div style={{ marginTop: "10px" }}>
                <p style={{ color: "#585966", fontWeight: 600, fontSize: "12px", margin: "0 0 3px 0" }}>Actions</p>
                {actions.map((a, i) => (
                  <p key={i} style={{ color: "#969696", fontSize: "12px", margin: "0 0 2px 0" }}>{a}</p>
                ))}
              </div>
            )}
          </div>
  
          {/* RIGHT */}
          <div style={{ minWidth:0, display: "flex", overflow:"hidden", textOverflow:"ellipsis", flexDirection:"column", alignItems:"flex-end", marginRight:"4px", fontSize:"12px", gap:"5px"}}>
            {rightContent}
          </div>
        </div>
  
        {/* FOOTER */}
        {footer && (
          <div style={{ fontSize: "10px", opacity: 0.8 }}>
            {footer}
          </div>
        )}
      </div>
    );
  };

  export default RuleCard;
  